<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/driverDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Settings</li>
    </ol>
  </nav>
  <form>
    <div class="row align-items-center ">
      <div class="col-md-8">
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a (click)="populateTabData('profile');" [ngClass]="{'active': tabClicked === 'profile'}">Profile</a></li>
          <li class="list-inline-item"><a (click)="populateTabData('changePassword'); " [ngClass]="{'active': tabClicked === 'changePassword'}">Security</a></li>
        </ul>
      </div>
    </div>

    <div class="row hide-sec" [ngClass]="{'show-sec': tabClicked === 'profile'}">
      <div class="row md-4">
      <div class="col-lg-12">
        <div class="inner-box">
          <div id="successMessage" class="text-success invalid-feedback d-block mb-3" [hidden]="!successMessage">{{successMessage}}</div>
          <div class="row mt-4">
            <div class="col-lg-8 col-md-8">
              <div class="row">
                <div class="col-md-4 required">
                  <div class="form-group ">
                    <label class="control-label" for="firstName"> Name</label>
                    <input type="text" id="firstName" maxlength="50" [(ngModel)]="driverDetails.driverName" class="form-control"  (blur)="typeDriverName()" [ngClass]="{'is-invalid':statusText}" [ngModelOptions]="{standalone: true}"   required>
                <div id="statusText" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText">{{statusText}}</div>

              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div>Email</div>
                <div><b>{{driverDetails.email}}</b></div>
              </div>
            </div>
            <div class="col-md-3" style="padding-left:60px">
              <div class="form-group">
                <div>Mobile Number</div>
                <div><b>{{driverDetails.mobileNumber}}</b></div>
              </div>
            </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <div>Address</div>
                    <div><b>{{driverDetails.address}}</b></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label>&nbsp;</label>
              <div class="upload-box" *ngIf="!imageUrl">
                <input type="file" [(ngModel)]="imageUrl" (change)="loadImage($event)">
                <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
                <div>upload logo</div>
              </div>
              <div class="upload-box mt-2" *ngIf="imageUrl">
                <img class="shift-uploaded-img shift-image" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"  width="250" height="250" />
                <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
                <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="150" height="150" />
                <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="100" height="100" />
                <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="50" height="50" />

                <div class="overly">
                  <button class="btn">
                    <input type="file" [(ngModel)]="imageUrl" (change)="loadImage($event)">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>Upload</button>
                  <button class="btn" (change)="ignoreImage()">
                    <input type="file" (change)="ignoreImage()">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>Remove</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-right">
          <button type="submit" class="btn btn-orange ml-2" (click)="submitDriver()">Save</button>
        </div>
      </div>
    </div>

    <div class="row hide-sec" [ngClass]="{'show-sec': tabClicked === 'changePassword'}">
      <div class="col-lg-14">
        <div class="inner-box">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="password">Current Password</label>
              <input type="text" id="password" [(ngModel)]="password" class="form-control"
                       (blur)="typeCurrentPwd()" [ngClass]="{'is-invalid':currentPwdError}"[ngModelOptions]="{standalone: true}"   required>
                <div id="currentPwdError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!currentPwdError">{{currentPwdError}}</div>
              </div>
            </div>
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="changePassword">New Password</label>
                <input type="text" id="changePassword" maxlength="50" [(ngModel)]="changePassword" class="form-control"
                       (blur)="typeNewPwd()" [ngClass]="{'is-invalid':newPwdError}"  [ngModelOptions]="{standalone: true}"   required>
                <div id="newPwdError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!newPwdError">{{newPwdError}}</div>
              </div>
            </div>
           <div class="col-md-4 required">
             <div class="form-group ">
               <label class="control-label" for="reEnterPassword">Confirm Password</label>
               <input type="text" id="reEnterPassword" [(ngModel)]="reEnterPassword" class="form-control"
                       (blur)="typeConfirmPwd()" [ngClass]="{'is-invalid':confirmPwdError}" [ngModelOptions]="{standalone: true}"   required>
                <div id="confirmPwdError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!confirmPwdError">{{confirmPwdError}}</div>
              </div>
            </div>
        </div>
        </div>
      <div class="row mt-3">
        <div class="col text-right">
          <button type="submit" class="btn btn-orange ml-2" (click)="editAccountOwner()">Save</button>
        </div>
      </div>
    </div>
  </form>
</section>

<!--Upload Image Driver Model-Box-->
<div class="modal fade style-modal" id="upLoadImage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content modal-content-shift">
      <div class="modal-body">
        <div class="form-group btn-upload">
          <label for="file" class="shift-upload-img" [ngStyle]="{'background-image':'url('+ productImage +')', 'background-position': 'center', 'background-size': 'cover'}" style="width:234px; height:200px"></label>
          <input type="file" class="form-control-file"  (change)="loadImage($event)" id="file"  accept="image/*">
        </div>
        <div class="text-right mt-3">
          <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="ignoreImage()">Cancel</button>
          <button type="button" (click)="submitImage()" class="btn btn-cancel-okay ml-1 text-white"  data-toggle="modal" data-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
